import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Modal, Button, MagicInput } from 'hljd'
import store from '../store'

@observer
export default class extends Component {
  render() {
    const { visible, content } = store
    return (
      <Modal
        title={<span style={{ fontSize: 16 }}>店铺公告</span>}
        visible={visible}
        onOk={store.editNotice}
        onCancel={store.cancelModal}
        footer={[
          <Button key="back" onClick={store.cancelModal}>
            取消
          </Button>,
          <Button key="submit" type="primary" onClick={store.editNotice}>
            提交审核
          </Button>
        ]}
      >
        <div>
          <p style={{ color: '#ff5c5c', fontSize: 14, paddingBottom: 10 }}>
            *请勿发布电话号、微信号等联系信息，公告将在审核通过后显示
          </p>
          <MagicInput.TextArea
            showCount
            countPosition="inner"
            maxLength={500}
            autoSize={{ minRows: 8, maxRows: 8 }}
            onChange={e => store.changeField(e.target.value)}
            value={content}
          />
        </div>
      </Modal>
    )
  }
}
